import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function DigestTab(): JSX.Element {
  return (
    <div className="row">
      <div className="col col-md-12 digesttab" {...getTestProps({component: 'DigestTab', element: 'root'})}>
        <div className="enzymes" />
        <div className="fragments">
          <table className="table table-hover table-condensed fragments-table">
            <thead>
              <tr>
                <th>Start</th>
                <th>End</th>
                <th>Length</th>
                <th>Left Cutter</th>
                <th>Left Overhang</th>
                <th>Right Cutter</th>
                <th>Right Overhang</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate(DigestTab);
